import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import { Box, IconButton, Link, Typography } from '@mui/material'
import { ReactComponent as Whatsapp } from '../../../assets/icons/whatsapp.svg'
import { addressPropTypes } from '../../../common/propTypes'

const SPAIN_PHONE_PREFIX = '+34'
const PHONE_NUMBER_WITHOUT_PREFIX_LENGTH = 9

const checkIsMobileNumber = phoneNumber =>
  phoneNumber.length === PHONE_NUMBER_WITHOUT_PREFIX_LENGTH &&
  (phoneNumber.startsWith('6') || phoneNumber.startsWith('7'))

export const PhoneComponent = ({ phoneNumber, country }) => {
  const isMobileNumber = checkIsMobileNumber(phoneNumber)
  const isSpanishPhone = country === 'ES'

  const handleOpenWhatsapp = useCallback(phone => {
    // TODO: in the future, the prefix should come in the `phone` variable
    const phoneHasPrefix = phone.length > 9
    const phoneWithPrefix = phoneHasPrefix
      ? phone
      : `${SPAIN_PHONE_PREFIX}${phone}`
    window.open(`https://wa.me/${phoneWithPrefix}`, '_blank')
  }, [])

  if (isMobileNumber && isSpanishPhone)
    return (
      <Box>
        <IconButton size="small" color="primary">
          <Whatsapp />
        </IconButton>
        <Link onClick={() => handleOpenWhatsapp(phoneNumber)}>
          {phoneNumber}
        </Link>
      </Box>
    )

  return (
    <Typography variant="body2" color="neutral.dark">
      {phoneNumber}
    </Typography>
  )
}

PhoneComponent.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  country: PropTypes.string,
}

const Address = ({
  data,
  sx,
  className,
  isShippingSend,
  isShippingDetailDesktop,
}) => {
  const intl = useIntl()

  return (
    <Box sx={sx} className={className}>
      <Typography
        component="p"
        variant={isShippingDetailDesktop ? 'body2' : 'h3medium'}
        color="neutral.black"
      >
        {data.name}
      </Typography>
      <Typography
        variant={isShippingSend ? 'body1' : 'body2'}
        color="neutral.main"
      >
        {data.address}
      </Typography>
      <Typography
        variant={isShippingSend ? 'body1' : 'body2'}
        color="neutral.main"
      >
        {data.postalCode.postalCode} {data.postalCode.city}
        {', '}
        {intl.formatDisplayName(data.country, { type: 'region' })}
      </Typography>
      {data.phone ? (
        <PhoneComponent phoneNumber={data.phone} country={data.country} />
      ) : null}
    </Box>
  )
}

Address.propTypes = {
  data: addressPropTypes,
  sx: PropTypes.object,
  className: PropTypes.string,
  isShippingSend: PropTypes.bool,
  isShippingDetailDesktop: PropTypes.bool,
}

export default Address
